// src/pages/admin/UserTable.js
import React from 'react';
import { Table, Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const UserTable = ({
  users,
  loading,
  currentPage,
  pageSize,
  handleSearch,
  handleViewUser,
  handleEditUser,
  handleDeactivateUser,
  handleAddUser,
  handleTableChange,
  sortColumn,
  sortOrder,
  handleAssignPermissions, // Added back for Roles.js compatibility
}) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: sortColumn === 'name' ? sortOrder : null,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
      sortOrder: sortColumn === 'email' ? sortOrder : null,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      sorter: true,
      sortOrder: sortColumn === 'role' ? sortOrder : null,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      sortOrder: sortColumn === 'status' ? sortOrder : null,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size="middle">
          {handleViewUser && (
            <Button onClick={() => handleViewUser(record)}>View</Button>
          )}
          {handleEditUser && (
            <Button onClick={() => handleEditUser(record.id)}>Edit</Button>
          )}
          {handleAssignPermissions && (
            <Button onClick={() => handleAssignPermissions(record)}>
              Assign Permissions
            </Button>
          )}
          {handleDeactivateUser && (
            <Button
              onClick={() => handleDeactivateUser(record.id)}
              danger={record.status === 'Active'}
            >
              {record.status === 'Active' ? 'Deactivate' : 'Activate'}
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Input
          placeholder="Search users..."
          prefix={<SearchOutlined />}
          onChange={(e) => handleSearch && handleSearch(e.target.value)} // Guard against undefined
          style={{ width: 300 }}
        />
        {handleAddUser && (
          <Button type="primary" onClick={handleAddUser}>
            Add User
          </Button>
        )}
      </div>
      <Table
        columns={columns}
        dataSource={users || []} // Default to empty array if users is undefined
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: users?.length || 0, // Guard against undefined users
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        rowKey="id"
      />
    </div>
  );
};

export default UserTable;